import { useEffect, useState } from "react";
import React from 'react';
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Select from "react-select";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import MovementReasonsSelect from "../components/MovementReasonsSelect";
import CampaignProvider from "../../../providers/CampaignProvider";
import UsersProvider from "../../../providers/UsersProvider";
import { useForm } from 'react-hook-form';
import ActionRequestButtons from "../components/ActionRequestButtons";
import requesterErrorMessages from '../../../static/messages/errorMessages.json';
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import useAlert from "../../../common/useAlert";


import ErrorMessage from "../components/ErrorMessage";


export const ManagerCampaignUpdate = React.memo(({ setApiRequestObj }) => {

  const { register, handleSubmit, formState: { errors }, getValues, setValue  } = useForm();
  const { alert } = useAlert();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [errorMessages, setErrorMessages] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [confirmManagerSelection, setConfirmManagerSelection] = useState(false);
  const [campaignAssigmentMessage, setCampaignAssigmentMessage] = useState(false);
  const [movementReasonId, setMovementReasonId] = useState(null);
  

  //1) Select Managers you want to assign campaigns
  //2) Generate List of selected managers and allow multi campaigns to be added. (Don't allow them to select campaigns to add they already have).

  const onSubmit = () => {
    for (let index = 0; index < selectedUsers.length; index++) {
      const user = selectedUsers[index];
      
      if(user?.NewCampaignAssignments === undefined){
        alert({
          icon:'error',
          title: `Missing Campaign Changes`,
          text: `Please add / remove a camapign from (Junior Manager Employee Number: ${user.value})`,
        });
        return;
      }
    }

    if(localStorage.getItem("EmployeeNumber")){
      setApiRequestObj({
        RequestType: 'UPDATE CAMPAIGNS',
        RequestDescription: "portal-request",
        CreatedBy: localStorage.getItem("UserName") || null,
        RequesterUserEmployeeNumber: localStorage.getItem("EmployeeNumber"),
        ApproverUserEmployeeNumber: localStorage.getItem("EmployeeNumber"),
        UserHierarchyMovementReasonId: movementReasonId,
        EffectiveDate: null,
        EmployeeMovements: selectedUsers.map((user) => ({
          EmployeeNumber: user.value,
          CampaignCodes: user.NewCampaignAssignments
        }))
      })
    }
  };
  const handleFormSubmit = handleSubmit(onSubmit);

  useEffect(async() => {
    let users;
    setFetching(true);

    if(localStorage.getItem('roleName') === "Admin"){
      const [juniorManagerUsers, feederJuniorManagerUsers, trainerUsers] = await Promise.all([
        UsersProvider.getUsersByRole({ roleName: 'Junior Manager' }),
        UsersProvider.getUsersByRole({ roleName: 'Feeder Junior Manager' }),
        UsersProvider.getUsersByRole({ roleName: 'Trainer' })
      ]);
    
       users = [...juniorManagerUsers, ...feederJuniorManagerUsers, ...trainerUsers];
       setManagerOptions(users);
       getCampaigns();
       setFetching(false);
    }
    if(localStorage.getItem('roleName') === "General Manager" || localStorage.getItem('roleName') === "Feeder General Manager"){
      await getCurrentManagerInfo(localStorage.getItem('userPrincipalName'))
      getCampaigns();
      setFetching(false);
    }
    
   

    setErrorMessages(requesterErrorMessages['teamManagement'].requests['userMovement']);
  }, [])

  const getCurrentManagerInfo = async(email) => {
    const managerData = await UsersProvider.getUsersSearch({ userPrincipalName: email });

    if(managerData && managerData.length === 1){
      if(managerData[0].SubordinateUsers && managerData[0].SubordinateUsers.length > 0){
        setManagerOptions(managerData[0].SubordinateUsers);
      }
    }
  }

  const updateUserListCampaignAssignment = (employeeNumber, campaigns, index) => {  
    let users = selectedUsers;
    let campignCodes = campaigns.map((campaign) => campaign.value);
    users[index].NewCampaignAssignments = campignCodes;
    users[index].currentlyAssignedCampaigns = campaigns.map((campaign) => ({
      Name: campaign.label,
      Code: campaign.value
    }));
    setSelectedUsers([...users]);
  };

  const getCampaigns = async() => {
    const campaigns = await CampaignProvider.getCampaigns();
    setCampaigns(campaigns);
  }

  const getManagerCampaigns = async() => {
    setFetching(true);
    const campaignsPromises = selectedUsers.map(async (user) => ({
      label: user.label,
      value: user.value, 
      currentlyAssignedCampaigns: await CampaignProvider.getManagerUserCampaigns(user.value)
    }));
    
    const managersCampaigns = await Promise.all(campaignsPromises);
    setSelectedUsers(managersCampaigns);
    setFetching(false);
  };

  const confirmManagers = async () => {
    if(selectedUsers && selectedUsers.length > 0){
      setConfirmManagerSelection(true);
      await getManagerCampaigns(selectedUsers);
    }
  }

  const selectManager = async(e) => {
    if(e && e.length > 5){
      alert({
        icon:'error',
        title: 'Maximum selection of 5 managers can be actioned at a time.',
      });
    }else{
      setSelectedUsers(e);

    }
  }  

  if(!errorMessages && fetching){
    return (
      <SuiBox><BeatLoader color={'#D0021B'} size={10} /> <SuiTypography variant="caption">Fetching Managers</SuiTypography></SuiBox>
    )
  }
  
  return (
    <>
    {errorMessages && <>
      <SuiBox mt={6} mb={6} lineHeight={1}>
        <SuiTypography variant="h6">Junior Manager Selection</SuiTypography>
        <SuiBox mt={1} position="relative">
          <Select
            key={`selectedUsers`}
            id={`selectedUsers`}
            register={register('selectedUsers', errorMessages['selectedUsers'])}
            isLoading={fetching}
            isDisabled={fetching || confirmManagerSelection}
            options={managerOptions.map((user) => ({
              value: user.EmployeeNumber,
              label: `${user.FullName	} ( ${user.EmployeeNumber} )`
            })) || []}
            value={selectedUsers}
            placeholder={`Select users you want to update`}
            onChange={(e) => {selectManager(e); setValue('selectedUsers', e);}}
            isSearchable={true}
            isMulti={true}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
          />
        </SuiBox>
        {errors['selectedUsers'] && <p className="error msg pad">{errorMessages['selectedUsers']['required']}</p>}
        <SuiBox mt={2} >
          {/* <SuiButton onClick={() => { setConfirmManagerSelection(false); }}>
            Edit Manager Selection
          </SuiButton> */}
          <SuiButton disabled={selectedUsers && selectedUsers.length == 0} onClick={() => { confirmManagerSelection ? setConfirmManagerSelection(false) : confirmManagers() }} color={`${confirmManagerSelection ? '' : 'info'}`}  >
            {confirmManagerSelection ?  'Edit Manager Selection' : 'Confirm Manager Selection'}
          </SuiButton>
        </SuiBox>
      </SuiBox>
      {confirmManagerSelection && <SuiBox mt={6} mb={2} lineHeight={1}>
          {selectedUsers && selectedUsers.length > 0 && <SuiTypography variant="h6">Campaign Assignment Selection</SuiTypography>}
          {selectedUsers && selectedUsers.length && !fetching > 0 ? selectedUsers.map((user, index) => {
            return (
              <>
              <SuiBox px={3}>
                <SuiBox key={user.value} display="grid" gridTemplateColumns=".6fr 1fr" mt={2} alignItems="center"> 
                  <SuiTypography sx={{fontSize: ".85rem"}} color="dark">{user.label}</SuiTypography>
                  <Select
                    key={`campaignAssignment`}
                    id={`campaignAssignment`}
                    register={register('campaignAssignment', errorMessages['campaignAssignment'])}
                    isLoading={fetching}
                    // isDisabled={fetchingData}
                    // styles={customStyles} 
                    options={campaigns.map((campaign) => ({
                      value: campaign.Code,
                      label: `${campaign.Code} (${campaign.Name})`
                    })) || []}
                    value={selectedUsers[index].currentlyAssignedCampaigns.map((campaign) => ({
                      value: campaign.Code,
                      label: `${campaign.Code} (${campaign.Name})`
                    })) || []}
                    placeholder={`Select campaigns`}
                    onChange={(e) => {updateUserListCampaignAssignment(user.value, e, index); setValue('campaignAssignment', e.value);}}
                    isSearchable={true}
                    isMulti
                    classNamePrefix="custom-select"
                    className="select-control select-one select-with-html"
                  />
                </SuiBox> 
              </SuiBox>
              </>
            )
          }): <SuiBox><BeatLoader color={'#D0021B'} size={10} /> <SuiTypography variant="caption">Fetching Manager Campaigns</SuiTypography></SuiBox>}
        {errors['campaignAssignment'] && <p className="error msg pad">{errorMessages['campaignAssignment']['required']}</p>}
      </SuiBox>}
      <SuiBox mt={6}>   
        <MovementReasonsSelect
          requestType={'movement'} 
          setReasonId={setMovementReasonId} 
          register={register}
          errorMessages={errorMessages}
          errors={errors} 
          setValue={setValue}
        />
       </SuiBox> 

      <ActionRequestButtons isDisabled={(selectedUsers && selectedUsers.length == 0) && fetching && !confirmManagerSelection} onSubmit={handleFormSubmit}/>
    </>}
    </>
  )
});
